export const BRAND_IDS = {
  CLAIM1: "CLAIM1",
  YCM: "YCM",
  MLM: "MLM",
};

export const MLM_ACTIVE_VARIATION = 2;

export const BRANDS = {
  [BRAND_IDS.CLAIM1]: {
    id: BRAND_IDS.CLAIM1,
    name: "Claims1",
    displayName: "Claims1",
    domains: ["mot.claims1.co.uk", "claims1.co.uk", "localhost"],
    email: "info@claims1.co.uk",
    supportEmail: "info@claims1.co.uk",

    reviewUrls: {
      customerReview: "https://claims1.co.uk/customer-review",
      google: "https://g.page/r/CY-5KuABk17iEAI/review",
      trustpilot: "https://www.trustpilot.com/evaluate/claims1.co.uk",
    },

    reviewProbabilities: {
      google: 0.5,
      trustpilot: 0.5,
    },

    colors: {
      primary: "#000000",
      secondary: "#00B3B3",
      accent: "#ff914d",
      brandColor: "#ff914d",
      brandButtonText: "#000000",
      currentColor: "#000000",
      altFontColor: "#000000",
      grayBg: "rgba(99, 136, 198, 0.05)",
      lightGrayBg: "#F7F7F7",
      extraLightGrayBg: "#F3F4F4",
      grayColor: "#171717",
      borderColor: "#dddddd",
      pinkColor: "#FEF3EF",
      disabledColor: "#BFCDCD",
      infoBoxBg: "#c3dfe0",
      infoBoxText: "#042020",
      alertBoxBg: "#002020",
      lenderBlockBg: "#cbf2f9",
      successColor: "#008F8F",
      darkBg: "#001A42",
      inputBorder: "#707070",
      lightBorder: "#ccc",
      whiteBg: "#ffffff",
      offWhiteBg: "#fff",
      lightGrayBorder: "#ddd",
      mediumGray: "#999",
      darkGray: "#666",
      textDark: "#333",
      hoverGray: "#f5f5f5",
    },

    logo: "/logos/claims1-logo.svg",
    favicon: "/logos/claims1-favicon.svg",
    font: "'Raleway', sans-serif",
    rating: 4.5,

    meta: {
      title: "Claims1 - MOT Signature",
      description: "Make your MOT claim with Claims1",
    },
  },

  [BRAND_IDS.YCM]: {
    id: BRAND_IDS.YCM,
    name: "YCM",
    displayName: "Your Claim Matters",
    domains: ["mot.ycmcarfinanceclaims.co.uk", "ycmcarfinanceclaims.co.uk"],
    email: "info@yourclaimmatters.co.uk",
    supportEmail: "info@yourclaimmatters.co.uk",

    reviewUrls: {
      customerReview: "https://www.yourclaimmatters.co.uk/customer-review",
      google: "https://g.page/r/CS9KenVF2ixsEAI/review",
      trustpilot: "https://www.trustpilot.com/evaluate/yourclaimmatters.co.uk",
    },

    reviewProbabilities: {
      google: 0.5,
      trustpilot: 0.5,
    },

    colors: {
      primary: "#0d86bc",
      secondary: "#ff914d",
      accent: "#0d86bc",
      brandColor: "#0d86bc",
      brandButtonText: "#ffffff",
      currentColor: "#000000",
      altFontColor: "#ffffff",
      grayBg: "rgba(255, 145, 77, 0.05)",
      lightGrayBg: "#FAFBFC",
      extraLightGrayBg: "#f2f5f7",
      grayColor: "#000000",
      borderColor: "#e1e8ed",
      pinkColor: "#FAFBFC",
      disabledColor: "#d0d0d0",
      infoBoxBg: "#E3F2FD",
      infoBoxText: "#000000",
      alertBoxBg: "#e67e22",
      lenderBlockBg: "#ffe8d6",
      successColor: "#ff914d",
      darkBg: "#3A4F66",
      inputBorder: "#000000",
      lightBorder: "#e1e8ed",
      whiteBg: "#ffffff",
      offWhiteBg: "#fff",
      lightGrayBorder: "#e1e8ed",
      mediumGray: "#999",
      darkGray: "#666",
      textDark: "#000000",
      hoverGray: "#fff0e6",
    },

    logo: "/logos/ycm-logo.svg",
    favicon: "/logos/ycm-favicon.svg",
    font: "'Raleway', sans-serif",
    rating: 4.4,

    meta: {
      title: "Your Claim Matters - MOT Signature",
      description: "Make your MOT claim with Your Claim Matters",
    },
  },

  [BRAND_IDS.MLM]: {
    id: BRAND_IDS.MLM,
    name: "MLM",
    displayName: "My Law Matters",
    domains: ["mot.mlmcarfinanceclaims.co.uk", "mlmcarfinanceclaims.co.uk"],
    email: "info@mylawmatters.co.uk",
    supportEmail: "info@mylawmatters.co.uk",

    reviewUrls: {
      customerReview: "https://mylawmatters.co.uk/customer-review",
      google: "https://g.page/r/MLM/review",
      trustpilot: "https://www.trustpilot.com/evaluate/mylawmatters.co.uk",
    },

    reviewProbabilities: {
      google: 0.7,
      trustpilot: 0.3,
    },

    variations: {
      1: {
        logo: "/logos/mlm-logo.svg",
        favicon: "/logos/mlm-favicon.svg",
        primary: "#000000",
        secondary: "#1e1b4b",
        accent: "#eab308",
        brandColor: "#eab308",
        brandButtonText: "#000000",
        currentColor: "#000000",
        altFontColor: "#ffffff",
        grayBg: "rgba(99, 136, 198, 0.05)",
        lightGrayBg: "#F7F7F7",
        extraLightGrayBg: "#F3F4F4",
        grayColor: "#171717",
        borderColor: "#dddddd",
        pinkColor: "#FEF3EF",
        disabledColor: "#BFCDCD",
        infoBoxBg: "#bfdbfe",
        infoBoxText: "#042020",
        alertBoxBg: "#002020",
        lenderBlockBg: "#bfdbfe",
        successColor: "#1e1b4b",
        darkBg: "#001A42",
        inputBorder: "#707070",
        lightBorder: "#ccc",
        whiteBg: "#ffffff",
        offWhiteBg: "#fff",
        lightGrayBorder: "#ddd",
        mediumGray: "#999",
        darkGray: "#666",
        textDark: "#333",
        hoverGray: "#f5f5f5",
      },
      2: {
        logo: "/logos/mlm-logo-v2.png",
        favicon: "/logos/mlm-favicon-v2.svg",
        primary: "#BB0000",
        secondary: "#F8E5E5",
        accent: "#BB0000",
        brandColor: "#BB0000",
        brandButtonText: "#ffffff",
        currentColor: "#000000",
        altFontColor: "#ffffff",
        grayBg: "#FDF5F5",
        lightGrayBg: "#f8f9fa",
        extraLightGrayBg: "#fefefe",
        grayColor: "#000000",
        borderColor: "#BB0000",
        pinkColor: "#F8E5E5",
        disabledColor: "#dee2e6",
        infoBoxBg: "#F8E5E5",
        infoBoxText: "#000000",
        alertBoxBg: "#fff3cd",
        lenderBlockBg: "#FDF5F5",
        successColor: "#BB0000",
        darkBg: "#133d6a",
        inputBorder: "#ced4da",
        lightBorder: "#e0e0e0",
        whiteBg: "#ffffff",
        offWhiteBg: "#f9f9f9",
        lightGrayBorder: "#dee2e6",
        mediumGray: "#999999",
        darkGray: "#666666",
        textDark: "#333333",
        hoverGray: "#F8E5E5",
      },
    },

    get colors() {
      return this.variations[MLM_ACTIVE_VARIATION];
    },

    get logo() {
      return this.variations[MLM_ACTIVE_VARIATION].logo;
    },

    get favicon() {
      return this.variations[MLM_ACTIVE_VARIATION].favicon;
    },
    font: "'Raleway', sans-serif",
    rating: 4.6,

    meta: {
      title: "My Law Matters - MOT Signature",
      description: "Make your MOT claim with My Law Matters",
    },
  },
};

export const CSS_VARIABLES = {
  "--theme-color-1": "primary",
  "--theme-color-2": "secondary",
  "--theme-color-3": "accent",
  "--ycm-orange": "brandColor",
  "--brand-button-text": "brandButtonText",
  "--current-color": "currentColor",
  "--alt-font-color": "altFontColor",
  "--gray-bg": "grayBg",
  "--light-gray-bg": "lightGrayBg",
  "--extra-light-gray-bg": "extraLightGrayBg",
  "--gray-color": "grayColor",
  "--border-color": "borderColor",
  "--pink-color": "pinkColor",
  "--disabled-color": "disabledColor",
  "--info-box-bg": "infoBoxBg",
  "--brand-info-bg": "infoBoxBg",
  "--info-box-text": "infoBoxText",
  "--alert-box-bg": "alertBoxBg",
  "--lender-block-bg": "lenderBlockBg",
  "--success-color": "successColor",
  "--dark-bg": "darkBg",
  "--input-border": "inputBorder",
  "--light-border": "lightBorder",
  "--white-bg": "whiteBg",
  "--off-white-bg": "offWhiteBg",
  "--light-gray-border": "lightGrayBorder",
  "--medium-gray": "mediumGray",
  "--dark-gray": "darkGray",
  "--text-dark": "textDark",
  "--hover-gray": "hoverGray",
  "--current-font": "font",
};

export const DEFAULT_BRAND = BRANDS[BRAND_IDS.CLAIM1];
